import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { KeyValue, Loading } from '@folio/stripes-components';
import TranslationRate from './components/TranslationRate';

function TranslationsStats({ statsData, currentLocale, categoryName }) {
  const intl = useIntl();

  if (!statsData) return <Loading />;

  const {
    total          = 0,
    translated     = 0,
    notTranslated  = 0,
    sameAsSource   = 0,
    completionRate = 0,
    byApp          = [],
    byTable        = [],
    byTranslator   = [],
  } = statsData;

  const contentData = total > 0 ? [{ total }] : [];

  return (
    <div style={{ padding: '1rem' }}>
      <TranslationRate
        ContentData={contentData}
        completed={completionRate}
        bgcolor={completionRate >= 80 ? '#4caf50' : completionRate >= 40 ? '#ff9800' : '#f44336'}
      />

      <br />

      <KeyValue
        label={<FormattedMessage id="ui-translations.stats.totalKeys" defaultMessage="Total keys" />}
        value={total}
      />
      <KeyValue
        label={<FormattedMessage id="ui-translations.stats.translated" defaultMessage="Translated" />}
        value={translated}
      />
      <KeyValue
        label={<FormattedMessage id="ui-translations.stats.notTranslated" defaultMessage="Not translated" />}
        value={notTranslated}
      />
      <KeyValue
        label={<FormattedMessage id="ui-translations.stats.sameAsSource" defaultMessage="Same as source" />}
        value={sameAsSource}
      />

      {byApp.length > 0 && (
        <>
          <br />
          <strong>
            <FormattedMessage id="ui-translations.stats.byApp" defaultMessage="By application" />
          </strong>
          {byApp.map((app) => (
            <KeyValue
              key={app.appName}
              label={intl.formatMessage({
                id: `${app.appName}.meta.title`,
                defaultMessage: app.appName.replace('ui-', ''),
              })}
              value={`${app.translated}/${app.total} (${app.rate}%)`}
            />
          ))}
        </>
      )}

      {byTable.length > 0 && (
        <>
          <br />
          <strong>
            <FormattedMessage id="ui-translations.stats.byTable" defaultMessage="By table" />
          </strong>
          {byTable.map((tbl) => (
            <KeyValue
              key={`${tbl.appName}-${tbl.tableName}`}
              label={intl.formatMessage({
                id: `ui-translations.filters.TableFilter.${tbl.tableName}`,
                defaultMessage: tbl.tableName,
              })}
              value={`${tbl.translated}/${tbl.total} (${tbl.rate}%)`}
            />
          ))}
        </>
      )}
    </div>
  );
}

TranslationsStats.propTypes = {
  statsData: PropTypes.shape({
    total:          PropTypes.number,
    translated:     PropTypes.number,
    notTranslated:  PropTypes.number,
    sameAsSource:   PropTypes.number,
    completionRate: PropTypes.number,
    byApp:          PropTypes.arrayOf(PropTypes.object),
    byTable:        PropTypes.arrayOf(PropTypes.object),
    byTranslator:   PropTypes.arrayOf(PropTypes.object),
  }),
  currentLocale: PropTypes.string,
  categoryName:  PropTypes.string,
};

export default TranslationsStats;
